import Axios from "axios";
import baseStore from '../generic_store';

const base = baseStore('upload');

const state = {
    ...base.state,
    base_url: '/api/upload',
    list: {},
    type: null,
    folder: null,
};

const getters = {
    ...base.getters,
};

const actions = {
    ...base.actions,
    push({commit}, {name, path}) {
        commit('STORE_ITEM', {name, path})
    },
    revert({state, commit, getters}, {path, name, load}) {
        Axios.post(getters.base_url + '/revert/', {
            path: path
        })
            .then( () => {
                commit('DELETE_ITEM', {name: name, path: path});
                load();
            })
            .catch( error => {
                console.warn(error)
            });
    },
    resetList({commit}) {
        commit('RESET_LIST');
    }
};

const mutations = {
    ...base.mutations,
    STORE_ITEM(state, { path, name }) {
        if(state.list[name]) {
            state.list[name].push(path)
        }else {
            state.list[name] = [path]
        }
    },
    DELETE_ITEM(state, {name, path}) {
        state.list[name] = state.list[name].filter( item => item !== path )
    },
    SET_TYPE(state, type) {
        state.type = type
    },
    RESET_LIST(state) {
        state.list = Object.assign({}, JSON.parse(JSON.stringify({})))
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

